import { render, staticRenderFns } from "./ChannelCooperation.vue?vue&type=template&id=394ba070&scoped=true&"
import script from "./ChannelCooperation.vue?vue&type=script&lang=js&"
export * from "./ChannelCooperation.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCooperation.vue?vue&type=style&index=0&id=394ba070&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ba070",
  null
  
)

export default component.exports